import { TranslatableKey } from '@app/types/translatable.type';

/** @deprecated */
const DriveNameDisplayOptions: { [key: string]: TranslatableKey } = {
    'Shared Documents': 'document.sharedDocuments',
    'Private Documents': 'document.privateDocuments',
    'My Documents': 'document.myDocuments',
};

// Left side is a hardcoded string in database, right side is the new name for recycled concept
const DriveNameDisplayOptionsV2: { [key: string]: TranslatableKey } = {
    'Shared Documents': 'document.companyDocuments',
    'Private Documents': 'document.templateLibrary',
    'My Documents': 'document.myDocuments',
};

// Left side is a hardcoded string in database, right side is folder icon
const DriveNameFolder: { [key: string]: string } = {
    'Shared Documents': 'folderShared',
    'Private Documents': 'folderPrivate',
    'My Documents': 'folderPrivate',
};

const DriveTypeDisplayOptions: { [key: string]: TranslatableKey } = {
    public: 'document.companyDocuments',
    private: 'document.templateLibrary',
    employee: 'document.myDocuments',
};

export { DriveNameDisplayOptions, DriveNameDisplayOptionsV2, DriveNameFolder, DriveTypeDisplayOptions };
